module.exports = __webpack_public_path__ + "static/media/AlertUpdate.3062b70a.mp3";